import {styledByTheme} from '../../../../themes/architecture/styled-by-theme';
import {DialogHeaderDefaultBox} from './dialog-header.default.box';
import {DialogHeaderCipBox} from './dialog-header.cip.box';

export const DialogHeaderBox = styledByTheme(DialogHeaderDefaultBox)
    .forCip(DialogHeaderCipBox)
    .forWsopCip(DialogHeaderCipBox).apply();